$(function () {

    var checkoutFormSubmitted = false;

    $('input[name=payment_kind]').on('change', function () {
        Manogi.switchPaymentKind();

        $('#js-checkout-form').request('checkout::onSwitchPaymentKind', {
            success: function (response) {

            }
        });
    });

    $('.js-place-order').on('click', function (e) {
        if (!$(this).hasClass('is-creditcard-button')) {
            e.preventDefault();
            Manogi.disableButton($(this));
        }

        $(this).text('Bestellung wird gesendet...');
    });

    $('.js-cart-message').keyup($.debounce(250, function () {
        $('#js-checkout-form').request('checkout::onChangeMessage', {
            success: function (response) {

            }
        });
    }));


    $('.js-order-with-prepayment').on('click', function (e) {
        if (!checkoutFormSubmitted) {
            checkoutFormSubmitted = true;
            $.oc.stripeLoadIndicator.show();
            $('#js-checkout-form').request('prepayment::onSubmitOrder', {
                success: function (response) {
                    window.location.href = response['url'];
                }
            });
        }
    });

    $('.js-order-with-invoice').on('click', function (e) {
        if (!checkoutFormSubmitted) {
            checkoutFormSubmitted = true;
            $.oc.stripeLoadIndicator.show();
            $('#js-checkout-form').request('invoice::onSubmitOrder', {
                success: function (response) {
                    window.location.href = response['url'];
                }
            });
        }
    });

    $('.js-order-with-paydirekt').on('click', function (e) {
        if (!checkoutFormSubmitted) {
            checkoutFormSubmitted = true;
            $.oc.stripeLoadIndicator.show();
            $('#js-checkout-form').request('paydirekt::onSubmitOrder', {
                success: function (response) {
                    cl(response);
                    if (response['responseCode'] == 201) {
                        window.location.href = response['url'];
                    }
                    //window.location.href = response['url'];
                }
            });
        }
    });

    $('.js-switch-newsletter-groups').on('change', function () {
        $(this).request('checkout::onSwitchRequestNewsletter', {
            success: function (response) {

            }
        });
    });


});
